import { PRODUCTS } from './products';

export const STATS = [
  { display: '10+', to: 10, suf: '+', label: 'Years manufacturing precision tools' },
  { display: '2012', to: 2012, suf: '', label: 'Established in IMT Manesar' },
  { display: '16', to: 16, suf: '', label: 'Products across the range' },
  { display: '5', to: 5, suf: '', label: 'Core product families' },
];

export const WHY_TILES = [
  { k: '10+', t: 'A decade of excellence', d: 'Over ten years of manufacturing precision tools' },
  { k: 'Team', t: 'Skilled specialists', d: 'Dedicated to quality and precision' },
  { k: 'Infra', t: 'Modern infrastructure', d: 'Advanced production capabilities' },
  { k: 'Custom', t: 'Custom solutions', d: 'Tailored to client specifications' },
  { k: 'Hub', t: 'Well-connected', d: 'IMT Manesar for efficient logistics' },
];

export const PROCESS_STEPS = [
  { n: '01', t: 'Correct form', d: 'Remove small amounts of material to fix shape distortions' },
  { n: '02', t: 'Tight tolerances', d: 'Achieve precise dimensional accuracy' },
  { n: '03', t: 'Cross-hatch', d: 'Produce a pattern that aids lubrication retention' },
  { n: '04', t: 'Superior finish', d: 'Deliver robust, high-quality surface quality' },
];

export const INDUSTRIES = [
  'Automotive', 'Aerospace', 'Hydraulics', 'Energy',
  'Precision Machining', 'Surface Finishing', 'Quality Control', 'Tool & Die',
];

export const REQUIREMENT_OPTIONS = ['General enquiry', ...PRODUCTS.map((p) => p.name)];

// Contact / company details, kept in one place for reuse across contact + footer.
export const COMPANY = {
  name: 'V-Tech Industries',
  address: 'Plot No. 70, Sector 5, IMT Manesar, Gurugram, Haryana — 122050',
  email: 'vikas@v-tech.co.in',
  phones: ['+91 124 405 5367', '+91 9312 017 002'],
  web: 'https://www.v-tech.co.in',
  webLabel: 'www.v-tech.co.in',
};
